import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import "../../../assets/CSS/SuperStarContent.css";

const PostDetails = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState("");

  useEffect(() => {
    let isMounted = true;

    const event_id = props.match.params.id;

    axios.get(`/api/star/simple_post/pending/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setEvent(res.data.post);
        }
      }
    });
  }, [props.match.params.id, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/approve_post/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/post/approved");
        }
      });
    });
  };
  const decline = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/decline_post/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/post");
        }
      });
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-bg p-3 mb-3">
            {event.image ? (
              <img
                src={imageCdnUrl+event.image}
                alt=""
                className="img-fluid Banner-SME-b"
                style={{ maxHeight: "450px" }}
              />
            ) : (
              <ReactPlayer
                url={videoCdnUrl + event.video}
                playing={true}
                controls={true}
                volume={1}
                width="100%"
                maxHeight="450px" // style={{ margin: "0 auto" }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="col-md-12 mb-3">
        <div className="card card-bg shadow">
          <div className="card-body">
            <h5 className="text-light ">{event.title}</h5>

            <p className="text-light ">
              <Markup content={event.instruction} />
            </p>

            <h5 className="text-warning">Description</h5>
            <div className="under-line"></div>
            <p className="text-light mt-2">
              <Markup content={event.description} />
            </p>

            <div className="col-md-3 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
              <h5 className="text-warning pt-2 ">Fees : ${event.fee}</h5>
              <p className="text-light fw-bold pt-2">
                {moment(event.date).format("LL")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3 row">
        {event.star_approval < 1 ? (
          <>
            <div className="row me-2">
              <div className="col-md-2 mb-3 me-2">
                <button
                  className="btn btnConfirm w-100 text-dark fw-bold"
                  onClick={handleClick}
                >
                  Approved{" "}
                </button>
              </div>

              <div className="col-md-2 mb-3 me-2">
                <button
                  className="btn btnDecline w-100 text-dark fw-bold "
                  onClick={decline}
                >
                  Decline
                </button>
              </div>

              <div className="col-md-2 mb-3 me-2">
                <Link to={`/superstar/post/edit/${event.id}`}>
                  <button className="btn btnEditTest w-100 text-dark text-light fw-bold px-3">
                    Edit
                  </button>
                </Link>
              </div>
            </div>
          </>
        ) : event.star_id === event.created_by_id &&
          Number(event.status) < 1 ? (
          <div className="col-md-3 mb-3 me-1">
            <Link to={`/superstar/post/edit/${event.id}`}>
              <button className="btn btnEditTest w-100 text-dark fw-bold px-3">
                Edit
              </button>
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default PostDetails;
